import { createContext } from '@lyearn/core/utils/context';

import { PageLayoutContextType } from './types';

const [PageLayoutContextProvider, usePageLayoutContext] =
  createContext<PageLayoutContextType>('PageLayoutContext');

export { usePageLayoutContext };
export default PageLayoutContextProvider;
